import { http } from '../../config/axios'

 const findRelatorio = (params:any): Promise<any> => {
  const queryParams = params
                ? Object.keys(params)
                      .map((k) => encodeURIComponent(params[k]))
                      .join('/')
                : '';
  return http
    .get('api/relatorio/find/' + queryParams)
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro findRelatorio', error)
      throw Error(error.response.data)
    })
}

export default findRelatorio;
